// Generated types for SemanticMapSummaryTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { StepTaskReadAPI, StepTaskWriteAPI } from '../../llm_task/types/steptask';
import { StepTaskReadAPISchemaObject, StepTaskWriteAPISchemaObject } from '../../llm_task/types/steptask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SemanticMapSummaryTaskReadAPI extends StepTaskReadAPI {
}

export interface SemanticMapSummaryTaskWriteAPI extends StepTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SemanticMapSummaryTaskReadAPISchema: z.ZodType<SemanticMapSummaryTaskReadAPI> = StepTaskReadAPISchemaObject.extend({}).passthrough();

export const SemanticMapSummaryTaskWriteAPISchema: z.ZodType<SemanticMapSummaryTaskWriteAPI> = StepTaskWriteAPISchemaObject.extend({}).passthrough();
